import * as styles from './styles/countdownHero.module.css';

const CountdownUnit = ({ baseDigit, maxDigit = 0 }: { baseDigit: string; maxDigit: number; }) => {
  const prevDigit = baseDigit === '00' ? maxDigit : parseInt(baseDigit) - 1;
  const previousDigitArray = (prevDigit < 10 ? `0${prevDigit}` : `${prevDigit}`).split('');
  const digitArray = baseDigit.split('');

  return (
    <span>
      {previousDigitArray.map((digit, index) => {
        if (digitArray[index] === digit) {
          return <span className={styles.number} key={`${index}-${digit}`}>{digit}</span>;
        }
        return (
          <span key={`${index}-${digitArray[index]}`} className={styles.scrollDigit}>
            <span className={styles.number} key={`${index}-${digitArray[index]}`}>{digitArray[index]}</span>
            <span className={styles.number} key={`${index}-${digit}`}>{digit}</span>
          </span>
        );
      },
      )}
    </span>
  );
};
export default CountdownUnit;
